export default "__VITE_ASSET__vFkQ_mxz__"